import { createAsyncThunk } from "@reduxjs/toolkit";
import { UsersApi } from "../api";
import { UserRootState } from "..";

const fetchLoggedInUser = createAsyncThunk(
  "user/fetchLoggedInUser",
  async () => {
    return await UsersApi.getLoggedInUser();
  },
);

const loginUser = createAsyncThunk(
  "user/loginUser",
  async (
    args: {
      email: string;
      password: string;
      rememberMe: boolean;
    },
    { rejectWithValue },
  ) => {
    const { email, password, rememberMe } = args;
    const response = await UsersApi.logIn(email, password, rememberMe);
    if (response.errorMessage) {
      return rejectWithValue(response.errorMessage);
    }
    return response;
  },
);

const postUsedFeatures = createAsyncThunk(
  "users/postUsedFeatured",
  async (_: undefined, thunkApi) => {
    const state: UserRootState = thunkApi.getState() as UserRootState;
    if (state.user.user === null) return [];
    if (state.user.user.id < 1) return [];
    const response = await UsersApi.postUsedFeatures(
      state.user.user.id,
      state.user.usedFeatures,
    );
    if (!response.success) {
      return state.user.usedFeatures;
    }
    return [];
  },
);

export const UserThunks = {
  fetchLoggedInUser,
  loginUser,
  postUsedFeatures,
};
